<div mat-dialog-content>
  <p style="font-family: Lato; font-size: 14px;">
    Procedure Code entered is not part of any adopted policies for the selected State & Plan Type.
  </p>
</div>
<div mat-dialog-actions class="button-div">
  <button mat-button mat-dialog-close class="close-btn">Close</button>
</div>